const A = 800, O = 200, T = 1.25, L = 1;
export {
  L as DEFAULT_SCALE_FACTOR,
  O as MODAL_ANIMATION_DURATION,
  T as SCALE_FACTOR,
  A as TOOLTIP_DELAY
};
